"use client";
import Image from "next/image";
import { GridItem, SimpleGrid, VStack } from "@chakra-ui/react";
import { Heading, Text } from "@/elements";
import { useTextVariant } from "@/theme/hooks/useSectionStyle";
import { DEPLOYMENT_CONSTANTS } from "./constants";

const DeploymentComponent = () => {
  const textVariant = useTextVariant();
  return (
    <SimpleGrid columns={{ base: 1, sm: 3, md: 4 }} gap={12}>
      <GridItem colSpan={{ base: 1, sm: 3, md: 1 }} alignSelf={"center"}>
        <Heading as="h2" fontWeight={"400"} fontSize={"40px"}>
          Deployment Options
        </Heading>
      </GridItem>
      {DEPLOYMENT_CONSTANTS.map((item, index) => (
        <GridItem
          key={index}
          bg="linear-gradient(to bottom, #1E87F0, #114E8A)"
          color="white"
          borderRadius={"12px"}
        >
          <VStack p={8} gap={6} justifyContent={"space-between"} borderRadius={"12px"}>
            <Image
              alt={item.title}
              src={item.image}
              style={{ maxHeight: "50px", width: "52px" }}
            />
            <Heading as="h1" variant={"subTitle1"} fontWeight={600} textAlign={"center"}>
              {item.title}
            </Heading>
            <Text variant={textVariant} textAlign={"center"}>
              {item.text}
            </Text>
          </VStack>
        </GridItem>
      ))}
    </SimpleGrid>
  );
};

export default DeploymentComponent;
